export default {
    'name': 'patent-family',
    'label': 'patent-view.PatentFamily',
    'getComponent': () => import('./PatentFamily.vue'),
    'tabIndex': 8,
    'left': true,
    'right': true,
    'singleView': true,
    'exclusiveRoutePath': '/patent-family',
    'selfHandelPadding': true,
    'aclCheckKey': 'family',
};
